// extracted by mini-css-extract-plugin
module.exports = {"onethird":"icon-module--onethird--3uQZV","icontext":"icon-module--icontext--12Ny5","iconimg":"icon-module--iconimg--1C4jA"};